import { applyMiddleware, compose, createStore } from "redux";
import { createEpicMiddleware } from "redux-observable";
import { IdEnvironment } from "../constants/IdEnvironment";
import { DevTools } from "./DevTools";
export var configureStore = function (dependencies, rootReducer, rootEpic) {
    if (dependencies === void 0) { dependencies = {}; }
    var epicMiddleware = createEpicMiddleware({
        dependencies: dependencies,
    });
    var enhancerList = [applyMiddleware(epicMiddleware)];
    if (process.env.NODE_ENV === IdEnvironment.Development) {
        // Types are not correct and was not allowing parameter
        enhancerList.push(DevTools.instrument.call(DevTools, { maxAge: 5 }));
    }
    var enhancers = compose.apply(compose, enhancerList);
    var store = createStore(rootReducer, enhancers);
    epicMiddleware.run(rootEpic);
    return store;
};



//////////////////
// WEBPACK FOOTER
// ./src/setup/configureStore.ts
// module id = 1707
// module chunks = 3